module KendoWidgets
{
	export class UploadOptions implements kendo.ui.UploadOptions
	{
		async?: kendo.ui.UploadAsync;
		dropZone?: string;
		enabled?: boolean;
		files?: kendo.ui.UploadFile[];
		multiple?: boolean;
		showFileList?: boolean;
		template?: string | Function;
		validation?: kendo.ui.UploadValidation;
		width?: string | number;
		dropZoneHeight?: string | number;
		showDropzone?: boolean;
		showUploadButton?: boolean;
		allowedExtensions?: string[];
		parameters?: Map<string, string>;
		maxSize?: number;
		loadingElement?: HTMLElement;

		webApiPath?: string;
		webApiAuthKey?: string;
		addOnlyToCache?: boolean;
		getBytes?: boolean;

		label?: string;
		labelPosition?: LabelPositionEnum;
		labelClass?: string;
		inputText?: string;

		cancel?(e: kendo.ui.UploadCancelEvent): void;
		clear?(e: kendo.ui.UploadClearEvent): void;
		complete?(e: kendo.ui.UploadEvent): void;
		error?(e: kendo.ui.UploadErrorEvent): void;
		pause?(e: kendo.ui.UploadPauseEvent): void;
		progress?(e: kendo.ui.UploadProgressEvent): void;
		resume?(e: kendo.ui.UploadEvent): void;
		remove?(e: kendo.ui.UploadRemoveEvent): void;
		select?(e: kendo.ui.UploadSelectEvent): void;
		success?(e: kendo.ui.UploadSuccessEvent): void;
		upload?(e: kendo.ui.UploadUploadEvent): void;
	}

	export class Upload extends kendo.ui.Upload implements KendoWidget
	{
		private _dropZoneElement: HTMLElement;
		private _fileInfoElement: HTMLElement | null;
		private _parameters: Map<string, string>;
		private _uploading: boolean;
		private _cacheGuid: string;
		private _dropZone: HTMLElement;

		public controlType(): ControlTypeEnum { return ControlTypeEnum.Upload; }

		constructor(element: Element, options?: KendoWidgets.UploadOptions)
		{
			if (options == null)
				options = new KendoWidgets.UploadOptions();

			if (options.width == null) options.width = 190;
			if (options.dropZoneHeight == null) options.dropZoneHeight = 39;
			if (options.showUploadButton == null) options.showUploadButton = true;
			if (options.showDropzone == null) options.showDropzone = true;
			if (options.showFileList == null) options.showFileList = true;
			if (options.multiple == null) options.multiple = false;
			if (options.inputText == null) options.inputText = "Seleziona...";
			if (options.addOnlyToCache == null) options.addOnlyToCache = false;
			if (options.getBytes == null) options.getBytes = false;
			if (options.allowedExtensions == null) options.allowedExtensions = [];
			if (options.maxSize == null) options.maxSize = 104857600;			
			$(element).attr("type", "file");

			if (options.webApiPath == null)
			{
				options.webApiPath = "/api/UtilityWebApi/UploadFile";
				options.webApiAuthKey = "10(P9m+U3a@Mtt-Oeo";
			}

			//#region Validation
			if (options.validation == null)
			{
				if (options.allowedExtensions.length == 1 && options.allowedExtensions[0] == ".")
					options.allowedExtensions = undefined;

				options.validation = {
					allowedExtensions: options.allowedExtensions,
					maxFileSize: options.maxSize
				};
			}
			//#endregion

			//#region Width
			if (typeof (options.width) == "number")
				options.width = options.width + "px";
			(element as HTMLElement).style.cssText += "width: " + options.width;
			//#endregion

			//#region Web Api path
			if (options.async == null)
			{
				options.async = {
					saveUrl: options.webApiPath,
					autoUpload: true,
					removeUrl: "remove"
				};
			}
			//#endregion

			//#region Upload event
			let uploadUserOverride = options.upload;
			options.upload = function (e: kendo.ui.UploadUploadEvent)
			{
				let upload = e.sender as KendoWidgets.Upload;
				upload._cacheGuid = "";
				upload._uploading = true;
				upload.showLoading();

				if (uploadUserOverride != null)
					uploadUserOverride(e);

				if (e.isDefaultPrevented())
					(e.sender as KendoWidgets.Upload).hideLoading();

				let files: any[] | undefined = e.files;
				if (files == null)
				{
					vr.alert("Errore durante il caricamento del file");
					(e.sender as KendoWidgets.Upload).hideLoading(options!.loadingElement);
					that._uploading = false;
					return;
				}

				let xhr = e.XMLHttpRequest as JQueryXHR;
				if (xhr)
				{
					xhr.addEventListener("readystatechange", function ()
					{
						let upload = e.sender as KendoWidgets.Upload;
						if (xhr.readyState == 1 && !(xhr as any).headersSet)
						{
							xhr.setRequestHeader("AuthKey", options!.webApiAuthKey!);

							if (upload._parameters == null)
								upload._parameters = new Map<string, string>();

							upload._parameters.set("addOnlyToCache", String(options!.addOnlyToCache));
							upload._parameters.set("getBytes", String(options!.getBytes));
							upload._parameters.forEach((value, key, map) => xhr.setRequestHeader(key, value));

							(xhr as any).headersSet = true;
						}
					});
				}
			}
			//#endregion

			//#region Select event
			let selectUserOverride = options.select;
			options.select = function (e: kendo.ui.UploadSelectEvent)
			{
				if (selectUserOverride != null)
					selectUserOverride(e);

				if (!e.isDefaultPrevented())
				{
					if (e.files != null)
					{
						let allowedExtensions: string[] = [];
						if (options!.allowedExtensions != null)
						{
							allowedExtensions = options!.allowedExtensions!.map(k =>
							{
								return k.replace(".", "");
							});
						}
						let maxSize = options!.validation!.maxFileSize!;

						for (let file of e.files)
						{
							if (options!.allowedExtensions != null && options!.allowedExtensions.length > 0 && !allowedExtensions.includes(file.extension.replace(".", "").toLowerCase()))
							{
								vr.alert("Sono consentiti solo i seguenti tipi di file: " + allowedExtensions.toString());
								e.preventDefault();
								(e.sender as KendoWidgets.Upload).hideLoading(options!.loadingElement);
							}
							else if (maxSize != null && file.size > maxSize)
							{
								let kb = Math.ceil(maxSize / 1024);
								let mb = 0;
								if (kb >= 1024)
									mb = kb / 1024;

								let sizeMessage = (mb > 0) ? mb + "Mb" : kb + "Kb";
								vr.alert("Sono consentiti solo allegati di dimensione inferiore a " + sizeMessage);
								e.preventDefault();
								(e.sender as KendoWidgets.Upload).hideLoading(options!.loadingElement);
							}
						};
					}
				}
			}
			//#endregion

			//#region Error event
			let errorUserOverride = options.error;
			options.error = function (e: kendo.ui.UploadErrorEvent)
			{
				((e.sender) as KendoWidgets.Upload)._uploading = false;
				if (e.operation != "remove")
				{
					if (errorUserOverride != null)
						errorUserOverride(e);
					else
					{
						let response: any = null;
						let responseStatus : any = null;
						let xhr = e.XMLHttpRequest;
						if (xhr != null && xhr.responseText)
						{
							responseStatus = xhr.status;

							try
							{
								response = JSON.parse(xhr.responseText);
							}
							catch
							{
								response = null;
							}
						}

						if (responseStatus == 403) // Forbidden
						{
							location.replace("/");
							return;
						}

						let message = response?.InnerException?.ExceptionMessage;
						if (message == null || message == "")
							message = response?.Message;
						if (message == null || message == "")
							message = response?.ExceptionMessage;
						if (message == null || message == "")
							message = response?.error;
						if (message == null || message == "")
							message = "Si è verificato un problema";

						// Every sanitized body carries an explicit ShowErrorPopup; a missing one (the shared error
						// helper's anonymous 500, no parseable body) is a fault, so only an explicit false is a toast.
						if (response?.ShowErrorPopup !== false)
							vr.alert(message);
						else
							vr.notifyError(message);
					}

					(e.sender as KendoWidgets.Upload).hideLoading(options!.loadingElement);
				}
				else
				{
					$((e.sender as KendoWidgets.Upload)._dropZoneElement).show();

					if ((e.sender as KendoWidgets.Upload)._fileInfoElement != null)
						$((e.sender as KendoWidgets.Upload)._fileInfoElement!).hide();

					(e.sender as KendoWidgets.Upload)._fileInfoElement = null;
					(e.sender as KendoWidgets.Upload).hideLoading(options!.loadingElement);
				}
			}
			//#endregion

			//#region Success event
			let successUserOverride = options.success;
			options.success = function (e: kendo.ui.UploadSuccessEvent)
			{
				let upload = e.sender as KendoWidgets.Upload;
				upload._uploading = false;

				//#region Hide dropzone if single upload
				if (!options!.multiple && e.files != null && e.files.length > 0)
				{
					// Dropzone
					if (upload._dropZoneElement == null)
						upload._dropZoneElement = upload._dropZone;

					// File info
					if (upload._fileInfoElement == null)
						upload._fileInfoElement = $(upload._dropZoneElement.parentElement!).find(".k-file")[0];

					// Hide dropzone
					let dropZone = upload._dropZoneElement;
					$(dropZone).hide();
				}
				//#endregion

				upload.hideLoading(options!.loadingElement);
				upload._cacheGuid = e.response.cacheGuid;

				if (successUserOverride != null)
					successUserOverride(e);
			}
			//#endregion

			super(element, options);
			let that = this;

			this._parameters = new Map<string, string>();
			if (options.parameters != null)
				this._parameters = options.parameters;

			//#region Upload button
			let uploadButton = element.parentElement!.parentElement!.getElementsByClassName("k-upload-button")[0];
			if (!options.showUploadButton)
				$(uploadButton).hide();

			//#region Input text
			$(uploadButton).children("span").html(options.inputText);
			//#endregion

			//#endregion

			//#region Dropzone
			// Height
			this._dropZone = element.parentElement!.parentElement!;
			if (typeof (options.dropZoneHeight) == "number")
				options.dropZoneHeight = options.dropZoneHeight + "px";
			this._dropZone.style.cssText += "height: " + options.dropZoneHeight;

			// Text
			let dropZoneButton = this._dropZone.getElementsByTagName("em")[0];
			if (!options.showDropzone)
			{
				this._dropZone.style.cssText += "background-color: transparent; border:none;";
				dropZoneButton.style.cssText += "display: none !important; visibility: hidden !important; opacity: 0 !important;";
			}
			else
			{
				this._dropZone.lastElementChild!.innerHTML = "Trascina qui il file";
				dropZoneButton.style.cssText += "display: block !important; visibility: visible !important; opacity: 1 !important;";
			}
			//#endregion

			//#region Label
			if (options.label != null)
			{
				$("#" + element.id + "Label").remove();
				let label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						class: options.labelClass,
						height: 21,
						fontSize: 14
					});				

				//#region Label position
				if (options.labelPosition == null) options.labelPosition = LabelPositionEnum.Top;
				switch (options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							element.parentElement!.parentElement!.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.parentElement!.parentElement!.insertBefore(label, element.parentElement!.parentElement!.parentElement!.firstChild);
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							element.parentElement!.parentElement!.parentElement!.insertBefore(label, element.parentElement!.parentElement!.parentElement!.firstChild);
							label.style.cssText += "margin-right: 5px";
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");
							element.parentElement!.parentElement!.parentElement!.append(label);
							label.style.cssText += "margin-left: 5px";
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");
							element.parentElement!.parentElement!.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.parentElement!.parentElement!.append(label);
						}
						break;
				}
				//#endregion

				(element.parentElement!.parentElement!.parentElement! as HTMLElement).style.cssText += "width: " + options.width;
				$(element).parent().parent().parent().attr("id", element.id + "Parent");
				$(element).parent().parent().parent().addClass("controlParent");
			}
			//#endregion			
		}

		parameters(parameters: Map<string, string>)
		{
			if (parameters != null)
				this._parameters = parameters;

			return this._parameters;
		}

		clear()
		{
			this.clearAllFiles();
			this.element.parent().parent().parent().find(".k-dropzone").show();
		}

		get uploading(): boolean
		{
			return this._uploading;
		}

		open()
		{
			this.element.trigger("click");
		}

		cacheGuid(guid?: string)
		{
			if (guid != null)
				this._cacheGuid = guid;

			return this._cacheGuid;
		}

		//#region Visible
		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
					this.element.parent().parent().parent().show();
				else
					this.element.parent().parent().parent().hide();
			}

			return this.element.parent().parent().parent().is(":visible");
		}

		show()
		{
			this.visible(true);
		}

		hide()
		{
			this.visible(false);
		}

		dropZoneText(text: string)
		{
			this._dropZone.lastElementChild!.textContent = text;
		}		

		//#endregion

		//#region Support
		private showLoading(transparency: boolean = true, control?: kendo.ui.Widget | HTMLElement | null)
		{
			let opacity = "0.5";
			if (!transparency)
				opacity = "1";

			let controlId = "";

			// Background
			let backgroundWidth = "100%";
			let backgroundHeight = "100%";

			// Loader
			let loaderXPosition = "Calc(50% - 50px)";
			let loaderYPosition = "Calc(50% - 50px)";
			let loaderWidth = "80px";
			let loaderHeight = "80px";

			let zIndex: number = 2500000;

			let element = $(document.body);
			if (control == null)
			{
				if ((this.options as KendoWidgets.UploadOptions).loadingElement != null)
					control = (this.options as KendoWidgets.UploadOptions).loadingElement;
				else
					control = this.element.parent().parent()[0];
			}

			if (control != null)
			{
				if (control instanceof HTMLElement)
					element = $(control);
				else
					element = control.element;

				if (element != null)
				{
					let position = $(element).offset();
					let elementWidth = $(element).outerWidth();
					let elementHeight = $(element).outerHeight();

					// Background
					backgroundWidth = elementWidth + "px";
					backgroundHeight = elementHeight + "px";

					// Loader
					let loaderWidthNumber = ((elementHeight) * 80 / 100);
					if (loaderWidthNumber > 80)
						loaderWidthNumber = 80;
					let loaderHeightNumber = ((elementHeight) * 80 / 100);
					if (loaderHeightNumber > 80)
						loaderHeightNumber = 80;

					loaderXPosition = (0 + ((elementWidth) / 2) - (loaderWidthNumber / 2)) - 5 + "px";
					loaderYPosition = (0 + ((elementHeight) / 2) - (loaderHeightNumber / 2)) - 5 + "px";
					loaderWidth = loaderWidthNumber + "px";
					loaderHeight = loaderHeightNumber + "px";

					controlId = $(element).attr("id");

					zIndex = (element.css("z-index")).getNumericPart() + 1;
				}
			}

			if ($(element).css("position") != "absolute")
				$(element).css("position", "relative");

			// Background
			let backgroundPosition = $(element).offset();
			let background: HTMLDivElement = document.createElement("div");
			background.setAttribute("id", "DivBackgroundLoading" + controlId);
			background.setAttribute("style", "position: absolute; left: " + 0 + "; top: " + 0 + "; z-index: " + zIndex.toString() + "; background-color: #FFF; opacity: " + opacity + "; width: " + backgroundWidth + "; height: " + backgroundHeight + ";");
			$(background).appendTo(element[0]);

			// Loader
			let loader: HTMLDivElement = document.createElement("div");
			loader.setAttribute("id", "DivLoader" + controlId);
			loader.setAttribute("style", "z-index: " + (zIndex + 1).toString() + "; border: 5px solid #ccc; border-radius: 50%; border-top: 5px solid #3498db; width: " + loaderWidth + "; height: " + loaderHeight + "; position: absolute; left: " + loaderXPosition + "; top: " + loaderYPosition + "; -webkit-animation: spin 2s linear infinite; animation: spin 2s linear infinite;");
			$(loader).appendTo(element[0]);
		}

		private hideLoading(control?: kendo.ui.Widget | HTMLElement | null)
		{
			let controlId = "";
			if (control == null)
				control = this.element.parent().parent()[0];

			if (control != null)
			{
				let element = null;

				if (control instanceof HTMLElement)
					element = $(control);
				else
					element = (control as kendo.ui.Widget).element;

				if (element != null)
					controlId = $(element).attr("id");
			}

			let background: HTMLDivElement = document.getElementById("DivBackgroundLoading" + controlId) as HTMLDivElement;
			if (background != null)
				background.parentNode!.removeChild(background);

			let loader: HTMLDivElement = document.getElementById("DivLoader" + controlId) as HTMLDivElement;
			if (loader != null)
				loader.parentNode!.removeChild(loader);
		}
		//#endregion

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().parent().prependTo(element);
		}
		//#endregion
	}

	Upload.fn = Upload.prototype;
	Upload.fn.options = $.extend(true, {}, kendo.ui.Upload.fn.options);
	Upload.fn.options.name = "Upload";
	kendo.ui.plugin(Upload);
}

interface JQuery
{
	kendoUpload(options?: KendoWidgets.UploadOptions): JQuery;
}